<template>
    <v-container>
        <v-row class="ma" v-for="(item, index) of bidderIdGroupForSocialId" :key="`${index}`">
            <v-col class="text-h6 pl-6 d-flex">
                <span v-show="showBidderId">{{ item.bidder_id }}</span>
            </v-col>
            <v-col v-show="showSocialId">
                <v-row v-if="!isMobile" class="d-flex align-center">
                    <v-col cols="3">
                        <v-chip small class="mr-4"
                                color="indigo darken-3"
                                outlined>
                            <v-icon small class="material-icons mr-1">{{ item.icon }}</v-icon>
                            <span class="text-capitalize">{{ item.network }}</span>
                        </v-chip>
                    </v-col>
                    <v-col>
                        <span class="text-body-1 align-self-center">{{ item.username }}</span>
                    </v-col>
                </v-row>
                <span v-else class="text-body-2">{{ item.username }}</span>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 4 : 1" :class="$parent.$options.name === 'v-expansion-panel-content' ? 'mr-3' : 'mr-8' ">
                <div class="d-flex align-center">
                    <icon-base height="20" width="20" viewBox="0 0 100 225" icon-name="near">
                        <icon-near iconColor="rgba(0, 0, 0, 1)" />
                    </icon-base>
                    <span class="text-h5 ml-1">{{ item.price.NEAR }}</span>
                    <sup class="ml-1" v-show="item.price.USD">$ {{ item.price.USD }}</sup>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped>
</style>
<script>
import {} from "@mdi/js";
import IconBase from "../components/IconBase.vue";
import IconNear from "../components/IconNear.vue";

export default {
    name: "BnftCommissionBidRow",
    components: {
        IconBase,
        IconNear,
    },
    props: {
        bidderIdGroupForSocialId: Array,
        isMobile: Boolean,
        showSocialId: Boolean,
        showBidderId: Boolean,
        isInExpansionPanel: Boolean,
    },
    data: function () {
        return {};
    },
};
</script>
